import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import React from 'react'
import '../../css/homepage.css'

const EmployeeItems = ({employee}) => {
  return (
    <div className="bg-[#434242] text-white py-2 my-1 cursor-pointer text-xs space-x-2 rounded-sm px-4 grid grid-cols-5 transition-all ease-in-out duration-150 hover:translate-y-1 hover:scale-105 inputBox leftboxes">
      <p className="col-span-1 truncate self-center">{employee?.name}</p>
      <p className="col-span-1 truncate self-center">{employee?.department}</p>
      <p className="col-span-1 truncate self-center">
        {Number(employee?.salary).toFixed(2)}TRX
      </p>
      <p className="col-span-1 truncate self-center">{employee?.startdate}</p>
      <div className="col-span-1 flex justify-end">
        <EllipsisVerticalIcon color="#ffff" className="h-6" />
      </div>
    </div>
  );
}

export default EmployeeItems